export const SUPPORTED_CURRENCIES = [
  { value: 'RSD', label: 'Serbian Dinar (RSD)' },
  { value: 'USD', label: 'US Dollar (USD)' },
  { value: 'EUR', label: 'Euro (EUR)' },
] as const;
